import { PAYMENT_TARIFF } from '../../types';
import { getParameterFromURL } from './getParameterFromUrl';

export const getInternalProductIdFromName = (id: string) => {
  const isVetCareTariff =
    getParameterFromURL('tariff') === PAYMENT_TARIFF.V49 ||
    getParameterFromURL('paypal_tariff') === PAYMENT_TARIFF.V49;

  switch(id) {
    case '1 month plan for $29.99':
      return 'everydoggy_1MONTH_29_99_USD';
      break;
    case '3 months plan for $39.99':
      return 'everydoggy_3MONTH_39_99_USD';
      break;
    case '1 year for $69.99':
      return 'everydoggy_1YEAR_69_99_USD';
      break;
    case '1 month plan for $21.99':
      return 'everydoggy_1MONTH_21_99_USD';
      break;
    case '3 months plan for $29.99':
      return 'everydoggy_3MONTH_29_99_USD';
      break;
    case '1 year for $51.99':
      return 'everydoggy_1YEAR_51_99_USD';
      break;
    case '1 week for $9.99':
      return 'everydoggy_1WEEK_9_99_USD';
      break;
    case '1 week for $7.99':
      return 'everydoggy_1WEEK_7_99_USD';
      break;
    case '1 week for $12.99':
      return 'everydoggy_1WEEK_12_99_USD';
      break;
    case 'everydoggy_1MONTH_29_99_USD_TRAINER_CHAT':
      return 'everydoggy_1MONTH_29_99_USD_TRAINER_CHAT';
      break;
    case 'everydoggy_3MONTH_39_99_USD_TRAINER_CHAT':
      return 'everydoggy_3MONTH_39_99_USD_TRAINER_CHAT';
      break;
    case 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
      break;
    case 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY':
      return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
      break;
    case 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY':
      return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_19_99_TRAINER_CHAT_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$6.99 per 1w intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_6_99_EVERYDOGGY';
      break;
    case '$19.99 per 1m intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_19_99_EVERYDOGGY';
      break;
    case '$29.99 per 3m intro, then $59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_29_99_EVERYDOGGY';
      break;
    case '$4.99 per 1w intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_4_99_EVERYDOGGY';
      break;
    case '$14.99 per 1m intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_14_99_EVERYDOGGY';
      break;
    case '$19.99 per 3m intro, then $59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_19_99_EVERYDOGGY';
      break;   
    case '1 month plan for $31.99':
      return 'everydoggy_1MONTH_31_99_USD_EVERYDOGGY';
      break;
    case '3 months plan for $43.99':
      return 'everydoggy_3MONTH_43_99_USD_EVERYDOGGY';
      break;
    case '1 month plan for $23.99':
      return 'everydoggy_1MONTH_23_99_USD_EVERYDOGGY';
      break;
    case '3 months plan for $31.99':
      return 'everydoggy_3MONTH_31_99_USD_EVERYDOGGY';
      break;
    case '6 months plan for $149.99':
      return 'everydoggy_6MONTH_149_99_USD_EVERYDOGGY';
      break;
    case '1 month plan for $59.99':
      return 'everydoggy_1MONTH_59_99_USD_EVERYDOGGY';
      break;
    case '3 months plan for $101.99':
      return 'everydoggy_3MONTH_101_99_USD_EVERYDOGGY';
      break;
    case '6 months plan for $111.99':
      return 'everydoggy_6MONTH_111_99_USD_EVERYDOGGY';
      break;
    case '1 month plan for $44.99':
      return 'everydoggy_1MONTH_44_99_USD_EVERYDOGGY';
      break;
    case '3 months plan for $75.99':
      return 'everydoggy_3MONTH_75_99_USD_EVERYDOGGY';
      break; 
    case '1 month plan for £23.99':
      return 'everydoggy_1MONTH_23_99_GBP_EVERYDOGGY';
      break;
    case '3 months plan for £31.99':
      return 'everydoggy_3MONTH_31_99_GBP_EVERYDOGGY';
      break;
    case '1 year for £55.99':
      return 'everydoggy_1YEAR_55_99_GBP_EVERYDOGGY';
      break;
    case '1 month plan for £16.99':
      return 'everydoggy_1MONTH_16_99_GBP_EVERYDOGGY';
      break;
    case '3 months plan for £23.99':
      return 'everydoggy_3MONTH_23_99_GBP_EVERYDOGGY';
      break;
    case '1 year for £41.99':
      return 'everydoggy_1YEAR_41_99_GBP_EVERYDOGGY';
      break;
    case '$15.19 per 1m intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_15_19_EVERYDOGGY';
      break;
    case '$25.99 per 3m intro, then $79.99 per 3 months':
      return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_25_99_EVERYDOGGY';
      break;
    case '$37.99 per 6m intro, then $119.99 per 6 months':
      return 'everydoggy_6MONTH_119_99_USD_INTRO_180days_37_99_EVERYDOGGY';
      break;
    case '$11.69 per 1m intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_11_69_EVERYDOGGY';
      break;
    case '$19.99 per 3m intro, then $79.99 per 3 months':
      return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_19_99_EVERYDOGGY';
      break;
    case '$28.79 per 6m intro, then $119.99 per 6 months':
      return 'everydoggy_6MONTH_119_99_USD_INTRO_180days_28_79_EVERYDOGGY';
      break;
    case '$11.99 per 1m intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_11_99_EVERYDOGGY';
      break;

    case '$4.99 per 1w intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_4_99_EVERYDOGGY';
      break;
    case '$11.99 per 1m intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_11_99_EVERYDOGGY';
      break;

    case '$3.99 per 1w intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_3_99_EVERYDOGGY';
      break;
    case '$8.99 per 1m intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_8_99_EVERYDOGGY';
      break;

    case '$4.99 per 1w intro, then $59.99 per month':
      return 'everydoggy_1MONTH_59_99_USD_INTRO_7days_4_99_EVERYDOGGY';
      break;
    case '$11.99 per 1m intro, then $59.99 per month':
      return 'everydoggy_1MONTH_59_99_USD_INTRO_30days_11_99_EVERYDOGGY';
      break;
    case '$25.99 per 3m intro, then $119.99 per 3 months':
      return 'everydoggy_3MONTH_119_99_USD_INTRO_90days_25_99_EVERYDOGGY';
      break;

    case '$3.99 per 1w intro, then $59.99 per month':
      return 'everydoggy_1MONTH_59_99_USD_INTRO_7days_3_99_EVERYDOGGY';
      break;
    case '$8.99 per 1m intro, then $59.99 per month':
      return 'everydoggy_1MONTH_59_99_USD_INTRO_30days_8_99_EVERYDOGGY';
      break;
    case '$19.99 per 3m intro, then $119.99 per 3 months':
      return 'everydoggy_3MONTH_119_99_USD_INTRO_90days_19_99_EVERYDOGGY';
      break;

    case '$25.99 per 3m intro, then $59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_25_99_EVERYDOGGY';
      break;
    case '$3.99 per 1w intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$8.99 per 1m intro, then $39.99 per month':
      return 'everydoggy_1MONTH_39_99_USD_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$1.99 per 1w intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$6.99 per 1m intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$14.99 per 3m intro, then $79.99 per 3 months':
      return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$0.99 per 1w intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$9.99 per 3m intro, then $79.99 per 3 months':
      return 'everydoggy_3MONTH_79_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$3.99 per 1m intro, then $49.99 per month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_30days_3_99_NONE_NONE';
      break;

    case '$4.99 per 1w intro, then $29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$11.99 per 1m intro, then $29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$25.99 per 3m intro, then $49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$3.99 per 1w intro, then $29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$8.99 per 1m intro, then $29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$19.99 per 3m intro, then $49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '$1.99 per 1w intro, then $29.99 per 2 weeks':
      return isVetCareTariff
        ? 'everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_2WEEK_29_99_USD_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$6.99 per 1m intro, then $29.99 per 2 weeks':
      return isVetCareTariff
        ? 'everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_2WEEK_29_99_USD_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$14.99 per 3m intro, then $49.99 per 1 month':
      return isVetCareTariff
        ? 'everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_1MONTH_49_99_USD_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$0.99 per 1w intro, then $29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_USD_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$3.99 per 1m intro, then $29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_USD_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$9.99 per 3m intro, then $49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '€1.99 per 1w intro, then €29.99 per 2 weeks':
      return isVetCareTariff
        ? 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€6.99 per 1m intro, then €29.99 per 2 weeks':
      return isVetCareTariff
        ? 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€14.99 per 3m intro, then €49.99 per 1 month':
      return isVetCareTariff
        ? 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€0.99 per 1w intro, then €29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_EUR_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€3.99 per 1m intro, then €29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_EUR_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€9.99 per 3m intro, then €49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
      break;
    
    case '£1.99 per 1w intro, then £29.99 per 2 weeks':
      return isVetCareTariff
        ? 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_1_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£6.99 per 1m intro, then £29.99 per 2 weeks':
      return isVetCareTariff
        ? 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_6_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£14.99 per 3m intro, then £49.99 per 1 month':
      return isVetCareTariff
        ? 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_VET_CARE_EVERYDOGGY_EVERYDOGGY'
        : 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_14_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£0.99 per 1w intro, then £29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_GBP_INTRO_7days_0_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£3.99 per 1m intro, then £29.99 per 2 weeks':
      return 'everydoggy_2WEEK_29_99_GBP_INTRO_30days_3_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£9.99 per 3m intro, then £49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_9_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '£4.99 per 1w intro, then £49.99 per month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_7days_4_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£11.99 per 1m intro, then £49.99 per month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£25.99 per 3m intro, then £79.99 per 3 months':
      return 'everydoggy_3MONTH_79_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£3.99 per 1w intro, then £49.99 per month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_7days_3_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£8.99 per 1m intro, then £49.99 per month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_30days_8_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£19.99 per 3m intro, then £79.99 per 3 months':
      return 'everydoggy_3MONTH_79_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '1 month plan for $39.99':
      return 'everydoggy_1MONTH_39_99_USD_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$39.99 per 3m intro, then $59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_USD_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '1 month plan for £39.99':
      return 'everydoggy_1MONTH_39_99_GBP_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£14.99 per 1m intro, then £39.99 per month':
      return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£39.99 per 3m intro, then £59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_GBP_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '£11.99 per 1m intro, then £39.99 per month':
      return 'everydoggy_1MONTH_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£29.99 per 3m intro, then £59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_GBP_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '1 month plan for €39.99':
      return 'everydoggy_1MONTH_39_99_EUR_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€14.99 per 1m intro, then €39.99 per month':
      return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_14_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€39.99 per 3m intro, then €59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_EUR_INTRO_90days_39_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '€11.99 per 1m intro, then €39.99 per month':
      return 'everydoggy_1MONTH_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€29.99 per 3m intro, then €59.99 per 3 months':
      return 'everydoggy_3MONTH_59_99_EUR_INTRO_90days_29_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '$1.99 per 1m intro, then $29.99 per 1 month':
      return 'everydoggy_1MONTH_29_99_USD_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£1.99 per 1m intro, then £29.99 per 1 month':
      return 'everydoggy_1MONTH_29_99_GBP_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€1.99 per 1m intro, then €29.99 per 1 month':
      return 'everydoggy_1MONTH_29_99_EUR_INTRO_30days_1_99_EVERYDOGGY_EVERYDOGGY';
    
    case '$25.99 per 3m intro, then $64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$37.99 per 6m intro, then $94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$19.99 per 3m intro, then $64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$29.99 per 6m intro, then $94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$21.99 per 3m intro, then $64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$32.99 per 6m intro, then $94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$11.99 per 1m intro, then $39.99 per 2 weeks':
      return 'everydoggy_2WEEK_39_99_USD_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$21.99 per 3m intro, then $49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '$32.99 per 6m intro, then $49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_USD_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '£25.99 per 3m intro, then £64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£37.99 per 6m intro, then £94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£19.99 per 3m intro, then £64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£29.99 per 6m intro, then £94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£21.99 per 3m intro, then £64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£32.99 per 6m intro, then £94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£11.99 per 1m intro, then £39.99 per 2 weeks':
      return 'everydoggy_2WEEK_39_99_GBP_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£21.99 per 3m intro, then £49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£32.99 per 6m intro, then £49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_GBP_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
      break;

    case '€25.99 per 3m intro, then €64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_25_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€37.99 per 6m intro, then €94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_37_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€19.99 per 3m intro, then €64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_19_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€29.99 per 6m intro, then €94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_29_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€21.99 per 3m intro, then €64.99 per 3 months':
      return 'everydoggy_3MONTH_64_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€32.99 per 6m intro, then €94.99 per 6 months':
      return 'everydoggy_6MONTH_94_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€11.99 per 1m intro, then €39.99 per 2 weeks':
      return 'everydoggy_2WEEK_39_99_EUR_INTRO_30days_11_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€21.99 per 3m intro, then €49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_EUR_INTRO_90days_21_99_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€32.99 per 6m intro, then €49.99 per 1 month':
      return 'everydoggy_1MONTH_49_99_EUR_INTRO_180days_32_99_EVERYDOGGY_EVERYDOGGY';
      break;

    // v001/v002/v003 — flat 1-day test subscriptions
    case '$9.99 per 1 day':
      return 'everydoggy_1DAY_9_99_USD_EVERYDOGGY_EVERYDOGGY';
      break;
    case '€9.99 per 1 day':
      return 'everydoggy_1DAY_9_99_EUR_EVERYDOGGY_EVERYDOGGY';
      break;
    case '£9.99 per 1 day':
      return 'everydoggy_1DAY_9_99_GBP_EVERYDOGGY_EVERYDOGGY';
      break;
  }
  
};
